import { LinearProgress } from "@mui/material";
import { ComponentType, ReactNode, Suspense } from "react";

export function Loadable<T extends object>(Component: ComponentType<T>, fallback?: ReactNode) {
  const defaultFallback = <LinearProgress />;
  // const defaultFallback = <Skeleton variant='rounded' width={undefined} height={20} />;

  const WrappedComponent = (props: T) => (
    <Suspense fallback={fallback || defaultFallback}>
      <Component {...props} />
    </Suspense>
  );
  return WrappedComponent;
}
